import { create } from "zustand";
import { devtools } from "zustand/middleware";
import type { ManualPixel } from "@/types/model/ManualPixels";

const EMPTY_ARRAY: Array<{}> = [];

interface PixelsState {
  pixelData: Record<string, Array<{}>>;
  manualPixels: ManualPixel[];
  manualPixelsLoading: boolean;
  setPixelData: (platform: string, data: Array<{}>) => void;
  setManualPixels: (manualPixels: ManualPixel[]) => void;
  setManualPixelsLoading: (loading: boolean) => void;
}

export const selectPixelData = (platform: string) => (state: PixelsState) =>
  state.pixelData[platform] ?? EMPTY_ARRAY;

export const usePixelsStore = create<PixelsState>()(
  devtools(
    (set) => ({
      pixelData: {},
      manualPixels: [],
      manualPixelsLoading: false,
      setPixelData: (platform: string, data: Array<{}>) =>
        set((state) => ({
          pixelData: {
            ...state.pixelData,
            [platform]: data,
          },
        })),
      setManualPixels: (manualPixels: ManualPixel[]) =>
        set(() => ({
          manualPixels,
        })),
      setManualPixelsLoading: (loading: boolean) =>
        set(() => ({
          manualPixelsLoading: loading,
        })),
    }),
    { name: "PixelsStore" }
  )
);
